export default "__VITE_ASSET__Brwpdjyg__"